/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Notebook
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define('notebook/NewNotebookActionHandler', [ 'notebook/bundles/glass.min' ], entry => entry.NewNotebookActionHandler);
define('notebook/OpenNotebookActionHandler', [ 'notebook/bundles/glass.min' ], entry => entry.OpenNotebookActionHandler);
define('notebook/OpenWSNotebookHandler', [ 'notebook/bundles/glass.min' ], entry => entry.OpenWSNotebookHandler);
define('notebook/RunNotebookActionHandler', [ 'notebook/bundles/glass.min' ], entry => entry.RunNotebookActionHandler);
define('notebook/ShareNotebookActionHandler', [ 'notebook/bundles/glass.min' ], entry => entry.ShareNotebookActionHandler);
define('notebook/PropertyMenuNotebook', [ 'notebook/bundles/glass.min' ], entry => entry.PropertyMenuNotebook);
define('notebook/UploadModuleActionHandler', [ 'notebook/bundles/glass.min' ], entry => entry.UploadModuleActionHandler);

define('notebook/bundles/glass.bridge', () => {});
